import { Pipe, PipeTransform } from '@angular/core';
import { Pages } from '@shared/components/pagination/model';

@Pipe({
  name: 'getPage',
  standalone: true,
})
export class GetPagePipe implements PipeTransform {
  transform(page: Pages, currentPage: number, nbPage: number): { page?: number } {
    const p = nbPage;
    if (page.type === 'page') {
      currentPage = Number(page.label);
    }
    if (page.type === 'previous') {
      if (currentPage === 1) return {};
      currentPage--;
    }
    if (page.type === 'next') {
      if (currentPage === p) return { page: p };
      currentPage++;
    }
    if (page.type === 'skip5') {
      currentPage = currentPage + 5 > p ? p : currentPage + 5;
    }
    if (page.type === 'back5') {
      currentPage = currentPage - 5 < 1 ? 1 : currentPage - 5;
    }
    return currentPage === 1 ? {} : { page: currentPage };
  }
}
